import { Outlet, useLocation } from "react-router-dom";
import { ConnectionProvider } from "@/lib/connectionContext";
import { Sidebar } from "./Sidebar";

/**
 * Two-column app shell: persistent left sidebar (logo + account switcher +
 * nav + user menu) and a main content area. No global top header — pages
 * own their headers.
 *
 * The ConnectionProvider lives here so every authenticated page can read
 * the user's active account-context selection without prop-drilling.
 *
 * Pages render full-width with consistent padding. A few pages — canvas
 * editors, conversation replays — need every pixel with no padding at all,
 * so we opt them out via a path-prefix check below. Add new full-bleed
 * (zero-padding) routes here.
 */
const FULL_BLEED_PREFIXES = [
  "/agentflow/flows/", // Canvas editor — React Flow + side-by-side sandbox
];

export function AppShell() {
  const location = useLocation();
  const isFullBleed = FULL_BLEED_PREFIXES.some((p) => location.pathname.startsWith(p));

  return (
    <ConnectionProvider>
      <div className="flex min-h-screen">
        <Sidebar />
        <main className="min-w-0 flex-1">
          {isFullBleed ? (
            <Outlet />
          ) : (
            <div className="w-full px-8 py-10">
              <Outlet />
            </div>
          )}
        </main>
      </div>
    </ConnectionProvider>
  );
}
